export default __webpack_public_path__ + "static/media/rarity-rate-kat2.74753a8f.svg";